exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-c1d10a90] .gridcard div.parent .v-card {\n  display: none !important;\n}\n[data-v-c1d10a90] .ag-root-wrapper-body.ag-layout-normal {\n  height: auto !important;\n}\n", ""]);

// exports
